import intlMessages from '../actions/lang/en.json';

const initialState = {
  locale: 'en',
  messages: intlMessages
};

const intlReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_INTL':
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default intlReducer;
